"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = exports.routes = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Container_1 = require("./layout/Container");
const MainPage_1 = require("./components/MainPage");
const Page_1 = require("./components/Page");
const WikidotTethering_1 = __importDefault(require("./components/WikidotTethering"));
const DraftsList_1 = require("./components/Drafts/DraftsList");
const DraftCreate_1 = require("./components/Drafts/DraftCreate");
const DraftView_1 = require("./components/Drafts/DraftView");
const DraftEdit_1 = require("./components/Drafts/DraftEdit");
exports.routes = [
    {
        path: '/',
        component: MainPage_1.MainPage,
        exact: true,
    },
    {
        path: '/wikidot/tethering',
        component: WikidotTethering_1.default,
    },
    {
        path: '/drafts',
        component: DraftsList_1.DraftListContainer,
        exact: true,
    },
    {
        path: '/drafts/new',
        component: DraftCreate_1.DraftCreateContainer,
    },
    {
        path: '/drafts/:id/edit',
        component: DraftEdit_1.DraftEditContainer,
    },
    {
        path: '/drafts/:id',
        component: DraftView_1.DraftViewContainer,
    },
    {
        path: '/:pageName',
        component: Page_1.Page,
        preloadDataMethod: 'wikidot-page',
    },
];
function App() {
    if (typeof window !== 'undefined') {
        window.routerHistory = react_router_dom_1.useHistory(); // eslint-disable-line react-hooks/rules-of-hooks
    }
    return (react_1.default.createElement(Container_1.Container, null,
        react_1.default.createElement(react_router_dom_1.Switch, null, exports.routes.map(({ path, component, exact }) => (react_1.default.createElement(react_router_dom_1.Route, { path: path, component: component, exact: exact, key: path }))))));
}
exports.App = App;
//# sourceMappingURL=routes.js.map